import { createFileRoute } from '@tanstack/react-router';

import { DemandPartnerEditorPage } from '../features/demand/partners/components/DemandPartnerEditorPage/DemandPartnerEditorPage';

export const Route = createFileRoute('/demand/partners/edit/$demandPartnerId')({
  component: DemandPartnerEditRoute,
});

function DemandPartnerEditRoute() {
  const { demandPartnerId } = Route.useParams();
  return <DemandPartnerEditorPage demandPartnerId={demandPartnerId} />;
}
